import Blockly from "blockly";
import Schema from "../schema";

import { menu as player__health } from './player_health';
import { menu as player__items } from './player_items';
import { menu as player__visual } from './player_visual';
import { menu as player__misc } from './player_misc';

export const menu = {
  name: (<div className="text"><u>P</u>layer</div>),
  trigger: 'p',
  children: {
    player__health,
    player__items,
    player__visual,
    ...player__misc
  }
}

/* ****************************************************************************************************************
 * Achievements
 *
 * Non-public block, sends the users achievements status to chat.
 ******************************************************************************************************************/
Blockly.Blocks['achievements'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Send Achievements to Chat')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Sends the players achievements from Steam to chat.')
  }
}

Blockly.JSON['achievements'] = (block) => {
  return {
    action: 'achievements'
  }
}

Schema.registerAction('achievements', {
  "if": {
    "properties": {
      "action": {
        "const": "achievements"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});


